<template>
    <nut-popup pop-class="guide-popup" v-model:visible="visible" style="background-color: transparent"
        @close="closeModal">
        <div class="dialog-content">
            <div class="content-box">
                <div class="text">
                    <span v-if="['first'].includes(showType)">点击右上角“···”分享给好友吧</span>
                    <span v-if="['choujiang_invite', 'invite'].includes(showType)">点击右上角“···”邀请好友组队吧</span>
                    <span v-if="showType === 'orderShare'">点击右上角“···”邀请好友吧</span>
                    <span v-if="showType === 'together'">点击右上角“···”分享同享奖励吧</span>
                    <span v-if="showType === 'reward_high'">点击右上角“···”炫耀你的奖励吧</span>
                </div>
            </div>
            <div class="tip">（分享时请勿关闭此页面）</div>
        </div>
    </nut-popup>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import eventEmitter from '@utils/event';
import { collect_log } from '@utils/api';

eventEmitter.on('showShareGuideModal', (type: string) => {
    collect_log({
        op_code: "share",
    }).then(() => { })
    showType.value = type
    visible.value = true
});

const visible = ref(false)
const showType = ref('')


function closeModal() {
    visible.value = false
    eventEmitter.emit('regsnsShareBus', {}, {});
}

</script>

<style lang="scss" scoped>
.dialog-content {
    padding-top: 20px;
    padding-right: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 24px;

    .content-box {
        @include bg('jiantou_5');
        display: flex;
        align-items: flex-end;
        justify-content: center;
        box-sizing: border-box;
        padding-right: 5px;
        padding-bottom: 20px;

        span {
            font-size: 26px;
            color: #fff;
        }

        .text {
            width: 370px;
            height: 90px;
            // background-color: #acf;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
        }
    }

    .tip {
        font-size: 20px;
        color: #fff;
    }
}
</style>